import React from "react";
import { Header } from "../components";

export function HeaderContainer({ children }) {
  return (
    <Header>
      <Header.Frame>
        <Header.Logo />
        {/* <Header.ButtonLink
          onClick={() => {
            window.location.assign("https://qa.ezyvms.com/");
          }}
        >
          LOGIN
        </Header.ButtonLink> */}
      </Header.Frame>
      {children}
    </Header>
  );
}